import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BaseRolesService } from '../../../core/services/base-roles.service';
import { BaseErrorCodesEnum } from '../../../shared/enums/base-error-codes.enum';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { BASE_PERMISSIONS } from '../../../core/constants/base-permissions';
import { BASE_ROLES } from '../../../core/constants/base-roles';
import { BaseAvatarSize } from '../../../shared/components/avatar/base-avatar.component';
import { BaseApplicationSectionsInterface } from '../../../shared/interfaces/base-application-sections.interface';
import { TabWithPermissionsInterface } from '../../../shared/interfaces/base-tab-with-permissions.interface';

@Component({
  selector: 'base-header',
  templateUrl: './base-header.component.html',
})
export class BaseHeaderComponent implements OnInit {
  @Input() logo: string;
  @Input() logoSmall: string;
  @Input() sections: BaseApplicationSectionsInterface[] = [];
  @Input() userMenu: TabWithPermissionsInterface[] = [];
  @Input() isFullscreen = false;
  @Input() isResetPasswordPage = false;
  buttonSizes = BaseButtonSize;
  avatarSizes = BaseAvatarSize;
  applicationSections: BaseApplicationSectionsInterface[] = [];
  isPsp = false;
  isErrorPage = false;
  isError401 = false;
  isMagicTokenLoginPage = false;
  stazzleLogoUrl: string;

  constructor(
    private offcanvasService: NgbOffcanvas,
    private roleService: BaseRolesService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isErrorPage = this.route.snapshot.pathFromRoot.some((r) => !!r.routeConfig?.data?.['isErrorPage']);

    if (this.isErrorPage) {
      this.isError401 = this.router.url.includes(BaseErrorCodesEnum.error401.toString());
    }
    this.isMagicTokenLoginPage = this.router.url.includes('auth/magic-link/login');
    this.isPsp = this.roleService.isPsp();
    this.stazzleLogoUrl = this.roleService.hasWorkCouncilRole() ? '/offers' : '/dashboard';
    this.applicationSections = this.sections?.filter((option) => {
      return this.roleService.hasWorkCouncilRole()
        ? option.roleKeys.includes(BASE_ROLES.CUSTOMER_WORK_COUNCIL)
        : !option.featurePermissionKeys.length ||
            option.featurePermissionKeys.some((permission) =>
              this.roleService.hasFeaturePermission(permission as BASE_PERMISSIONS)
            );
    });
  }

  openOffcanvasSidebar(offcanvasSidebar: any, isRightSidebar: boolean = false): void {
    this.offcanvasService.open(offcanvasSidebar, {
      panelClass: 'navigation-offcanvas',
      position: isRightSidebar ? 'end' : 'start',
    });
  }
}
